import Component from '../abstracts/Component';

export default class BurgerComponent extends Component {

  get SELECTORS() {
    return {
      burger: '[data-burger]'
    }
  }

  get CLASSES() {
    return {
      active: 'is-active'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {

    this.$on(this.$customEvents.BACKDROP_EVENTS.hidden, () => {
      if ($(this.SELECTORS.burger).hasClass(this.CLASSES.active)) {
        $(this.SELECTORS.burger).removeClass(this.CLASSES.active);
        this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: false});
      }
    });

    this.$on('click.burger', () => {
      $(this.SELECTORS.burger).toggleClass(this.CLASSES.active);
      this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: $(this.SELECTORS.burger).hasClass(this.CLASSES.active)});
    }, this.SELECTORS.burger);

    this.$on(this.$customEvents.QUICK_CATEGORIES_EVENTS.visible, () => {
      setTimeout(() => {
        $(this.SELECTORS.burger).toggleClass(this.CLASSES.active);
        this.$emit(this.$customEvents.BURGER_EVENTS.click, {menuIn: $(this.SELECTORS.burger).hasClass(this.CLASSES.active)});
      }, 300);
    })
  }

  render() {
    this.bindEvents();
  }

}
